import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Target } from "lucide-react";
import { useLocation } from "wouter";

export function GoalsTeaser() {
  const [, navigate] = useLocation();

  return (
    <Card 
      className="bg-green-50 dark:bg-green-950 border-2 border-dashed border-primary"
      data-testid="card-goals-teaser"
    >
      <CardContent className="pt-8 pb-8 text-center">
        <div className="flex justify-center mb-4">
          <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center">
            <Target className="w-8 h-8 text-primary" />
          </div>
        </div>
        
        <h3 className="text-xl font-semibold mb-2">
          🎯 Social Media Ziele
        </h3>
        
        <p className="text-sm text-muted-foreground mb-6 max-w-md mx-auto">
          Später können Sie hier Ziele für Ihre Plattformen verfolgen. 
          Zuerst: Lassen Sie uns Ihren ersten Content erstellen!
        </p>
        
        <Button
          variant="outline"
          onClick={() => navigate('/goals')}
          data-testid="button-set-goals"
        >
          Ziele ansehen
        </Button>
      </CardContent>
    </Card>
  );
}
